import React, { useEffect, useMemo, useState } from 'react'
import { Box, Button, InputAdornment, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useLecturas } from '../hooks/useLecturas';
import { CustomModal } from '../components/Modal';
import { LecturaAguaItem } from '../components/LecturaAguaItem';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setReadingsData } from '../redux/readSlice';
import { Container } from '@mui/system';

export const LecturaAgua = () => {

    const itemsPerPage = 5
    const { getLecturas, syncLecturas } = useLecturas()

    const [openModal, setOpenModal] = useState(false)
    const [modalMessage, setModalMessage] = useState('')
    const [page, setPage] = useState(0)
    const [busqueda, setBusqueda] = useState('')

    const { readingsData } = useAppSelector((state) => state.readings)
    const dispatch = useAppDispatch()

    useEffect(() => {
        (async () => {
            const lecturas = await getLecturas()
            if (lecturas) {
                dispatch(setReadingsData(lecturas))
            }
            else{
                setModalMessage('Error al obtener el listado de lecturas')
                handleOpen()
            }
            if (navigator.onLine) await handleSyncLecturas()
        })()

        window.addEventListener('online', handleSyncLecturas)
        return () => window.removeEventListener('online', handleSyncLecturas)

    }, [])

    const handleSyncLecturas = async () => {
        return await syncLecturas()
    }

    const handleOpen = () => setOpenModal(true);
    const handleClose = () => {
        setOpenModal(false)
    };

    const filtradas = useMemo(() => {
        if (!readingsData || readingsData.length === 0) return [];
        if (!busqueda.trim()) return readingsData;
        return readingsData.filter(l => l.num_Casa.toLowerCase().includes(busqueda.trim().toLowerCase()));
    }, [readingsData, busqueda]);

    const totalPages = Math.max(1, Math.ceil(filtradas.length / itemsPerPage));

    return (
        <Box textAlign="center" display="flex" alignItems="center" flexDirection='column'>
            <Typography variant="h4" component="div" gutterBottom marginY='1em'>
                Lectura de Agua
            </Typography>

            <TextField
                size="small"
                placeholder="Buscar por No. Casa"
                value={busqueda}
                onChange={(e) => { setBusqueda(e.target.value); setPage(0); }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
                sx={{ width: { xs: '75%', md: '32%' }, mb: 2 }}
            />

            {filtradas.length > 0 && filtradas.slice(page * itemsPerPage, (page + 1) * itemsPerPage).map((lectura) => (
                <LecturaAguaItem lectura={lectura} key={lectura.num_Casa} />
            ))}

            {filtradas.length === 0 && busqueda.trim() && (
                <Typography color="text.secondary" sx={{ mt: 2 }}>No se encontraron casas con "{busqueda}"</Typography>
            )}

            <Container >

                <Button color='primary' sx={{margin:4 , width:'25%'}} onClick={() => setPage(page - 1)} disabled={page === 0} >
                    Pagina Anterior
                </Button>

                <Button color='primary' sx={{margin:4 , width:'25%'}} onClick={() => setPage(page + 1)} disabled={page + 1 >= totalPages} >
                    Pagina Siguiente
                </Button>

            </Container>

            <CustomModal openState={openModal} onCloseHandler={handleClose} >

                <Typography variant="h4" component="div" gutterBottom marginY='1em'>
                    {modalMessage}
                </Typography>

                <Button color='secondary' variant="outlined"  sx={{marginY:2 , width:'50%'}} onClick={handleClose} >
                    OK
                </Button>

            </CustomModal>
            
        </Box>
    )
}
